import { base_url } from "./url";

export const storeUserInfo = async (form) => {
    const response = await fetch(`${base_url}/digiact-user-info`, { method: 'POST', body: JSON.stringify(form), headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }, });
    const data = await response.text();
    if (response.ok) {
        return data;            
    }
    else {
        throw Error('Error storing user data');
    }
}

export const getUserInfo = async (userId) => {
    try{
        const response = await fetch(`${base_url}/digiact-user-get?user_id=${userId}`, { method: 'GET'});
        const data = await response.json();
        return data
    } catch(e) {
        return null;
    }
}

export const getCompletedTasksForUser = async(userId) => {
    try {
        const response = await fetch(`${base_url}/digiact-task-completion-get?user_id=${userId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        const {data} = await response.json();
        return data;
    }
    catch (e) {
        return [];
    }
}

export const markTaskAsCompleted = async (user_id, done_task_id) => {
    const response = await fetch(`${base_url}/digiact-task-completion`, { method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ user_id, done_task_id:`t${done_task_id}` }) });
    const data = await response.text()
    return data;
}